module.exports = __webpack_public_path__ + "static/dir_cover_image-7bd1fa17263b5c8456bd82c453c11ee9.jpg";